module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_teenagers-b42f15041e61501bb424210c442236d1.svg";